/*
 * DRIVLY-UI React Components
 * @license MIT
 */
const e="undefined"!=typeof document;export{e as isBrowser};
//# sourceMappingURL=is-browser.js.map
